var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'col-6 column items-center q-py-md cursor-pointer relative-position',
    { 'bg-white': _vm.active, 'bg-primary-semi-dark': !_vm.active }
  ],on:{"click":function($event){return _vm.$emit('select')}}},[_c('QImg',{attrs:{"src":_vm.active ? _vm.activeImg : _vm.img,"alt":"Novated lease","height":"38px","contain":"","basic":""}}),(_vm.label)?_c('span',{class:[
      'q-pt-sm',
      { 'text-primary-semi-dark': _vm.active, 'text-primary-semi-light': !_vm.active }
    ]},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),(_vm.loading)?_c('QSpinnerDots',{staticClass:"q-mt-xs",attrs:{"size":"md","color":_vm.active ? 'primary-semi-dark' : 'white'}}):_c('h4',{class:[
      'text-primary q-pt-xs',
      { 'text-primary-semi-dark': _vm.active, 'text-white': !_vm.active }
    ]},[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.monetaryValue))+" ")]),(_vm.active)?_c('div',{staticClass:"active-indicator"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }